import { render, staticRenderFns } from "./PlanDetailPage.vue?vue&type=template&id=16013d1e&scoped=true"
import script from "./PlanDetailPage.vue?vue&type=script&lang=js"
export * from "./PlanDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailPage.vue?vue&type=style&index=0&id=16013d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16013d1e",
  null
  
)

export default component.exports